/* Lumir · ajustes de marca. Los combos (Lleva 2 / Lleva 3) son solo para 100 ml: con 50 ml se ocultan. */
(() => {
  const es50 = () =>
    [...document.querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select')]
      .some(el => /^50\s*ML$/i.test((el.value || '').trim()));

  const aplicar = () => {
    const breaks = document.querySelector('quantity-breaks');
    if (!breaks) return;
    const solo1 = es50();
    breaks.querySelectorAll('label.quantity-break[data-quantity]').forEach(label => {
      if (Number(label.dataset.quantity) > 1) label.style.display = solo1 ? 'none' : '';
    });
    const marcado = breaks.querySelector('input[name="quantity"]:checked');
    if (solo1 && marcado && Number(marcado.value) > 1) breaks.querySelector('label.quantity-break[data-quantity="1"]')?.click();
  };

  // El tema vuelve a pintar el bloque al cambiar de variante: se aplica de nuevo un instante después.
  document.addEventListener('change', () => { setTimeout(aplicar, 50); setTimeout(aplicar, 600); });
  document.addEventListener('DOMContentLoaded', aplicar);
  aplicar();
})();

/* Botón fijo de Releasit en el celular. Releasit lo muestra siempre que su botón normal no se ve, también arriba
   de la página; aquí solo aparece después de pasar ese botón. Además se guarda su alto en --lumir-rsi-alto
   para apoyar encima la barra delgada del tema (nombre y precio). */
(() => {
  const root = document.documentElement;
  const revisar = () => {
    const normal = [...document.querySelectorAll('#rsi_buy_now_button')]
      .find(b => !b.closest('cart-drawer, #floatingBuyNowButton'));
    const antes = !!normal && normal.getBoundingClientRect().top > innerHeight;
    root.classList.toggle('lumir-rsi-antes', antes);
    const fijo = document.querySelector('#floatingBuyNowButton');
    // El botón va con position:fixed dentro de su caja, así que se mide el botón y no la caja (que mide 0).
    const boton = fijo && fijo.querySelector('button');
    const alto = boton && !antes && fijo.style.display !== 'none' ? Math.round(boton.getBoundingClientRect().height) : 0;
    root.style.setProperty('--lumir-rsi-alto', alto + 'px');
  };
  // Releasit muestra u oculta su botón medio segundo después del scroll: se revisa al momento y otra vez después.
  let espera;
  const alMover = () => { revisar(); clearTimeout(espera); espera = setTimeout(revisar, 650); };
  addEventListener('scroll', alMover, { passive: true });
  addEventListener('resize', alMover);
  [0, 800, 2000, 4000].forEach(ms => setTimeout(revisar, ms));
})();

/* Formulario de Releasit: la línea del descuento de los combos sale como "Discounts" (traducirla en Releasit es del plan
   Premium); aquí se cambia por "Ahorro combo" cada vez que Releasit pinta el resumen. */
(() => {
  const cambiar = () => {
    document.querySelectorAll('form:has(.rsi-submit_button)').forEach(form => {
      const textos = document.createTreeWalker(form, NodeFilter.SHOW_TEXT);
      for (let t; (t = textos.nextNode());) if (t.nodeValue.trim() === 'Discounts') t.nodeValue = t.nodeValue.replace('Discounts', 'Ahorro combo');
    });
  };
  let pendiente = false;
  new MutationObserver(() => { if (!pendiente) { pendiente = true; requestAnimationFrame(() => { pendiente = false; cambiar(); }); } })
    .observe(document.body, { childList: true, subtree: true, characterData: true });
})();
